import { SliderComponent } from '@webentorCore/_slider';

document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.b-people-slider .js-slider');

  sliders.forEach((element) => {
    const dataSlider = element.getAttribute('data-slider');
    const params = JSON.parse(dataSlider || '{}');
    const container = element.closest(
      '.js-people-slider-container',
    ) as HTMLElement;
    const wrapper = element.closest(
      '.js-b-people-slider-wrapper',
    ) as HTMLElement;
    const outerWrapper = container?.querySelector(
      '.js-people-slider-outer-wrapper',
    ) as HTMLElement;
    const sliderContainer = wrapper?.querySelector(
      '.js-swiper-container',
    ) as HTMLElement;

    // Initialize slider
    const sliderInstance = new SliderComponent(element, params);

    // Calculate and set wrapper dimensions
    const calculateContainerDimensions = () => {
      if (!wrapper || !outerWrapper || !sliderContainer) return;

      const rect = wrapper.getBoundingClientRect();
      wrapper.style.maxWidth = `${window.innerWidth - rect.left}px`;
      outerWrapper.style.minHeight = `${sliderContainer.offsetHeight}px`;
    };

    // Update slide classes and z-index based on position
    const updateSlides = (swiper: any) => {
      swiper.slides.forEach((slide: HTMLElement, index: number) => {
        slide.classList.remove('is-prev', 'is-next');

        if (index < swiper.activeIndex) {
          slide.classList.add('is-prev');
          slide.style.zIndex = '1';
        } else if (index === swiper.activeIndex) {
          slide.style.zIndex = '10';
        } else {
          slide.classList.add('is-next');
          slide.style.zIndex = String(9 - (index - swiper.activeIndex));
        }
      });
    };

    // Manual navigation handlers
    const setupNavigation = () => {
      const nextBtn = container?.querySelector('.js-people-slider-button-next');
      const prevBtn = container?.querySelector('.js-people-slider-button-prev');

      nextBtn?.addEventListener('click', () => {
        if (
          sliderInstance.swiper &&
          sliderInstance.swiper.activeIndex <
            sliderInstance.swiper.slides.length - 1
        ) {
          sliderInstance.swiper.slideNext();
        }
      });

      prevBtn?.addEventListener('click', () => {
        if (sliderInstance.swiper && sliderInstance.swiper.activeIndex > 0) {
          sliderInstance.swiper.slidePrev();
        }
      });
    };

    // Apply transforms with 75% overlap
    const applyTransforms = () => {
      if (!sliderInstance.swiper) return;

      const { slides, activeIndex } = sliderInstance.swiper;
      const slideWidth = slides[0]?.offsetWidth || 376;
      const spacing = -(slideWidth * 0.75);
      const baseOffset = -slideWidth * activeIndex;

      slides.forEach((slide: HTMLElement, index: number) => {
        let transform = '';

        if (index < activeIndex) {
          transform = `translate3d(${baseOffset - slideWidth}px, 0, 0)`;
        } else if (index === activeIndex) {
          transform = `translate3d(${baseOffset}px, 0, 0)`;
        } else {
          const offset = baseOffset + spacing * (index - activeIndex);
          transform = `translate3d(${offset}px, 0, 0)`;
        }

        slide.style.transform = transform;
      });
    };

    // Create custom pagination bullets
    const createPagination = () => {
      if (!sliderInstance.swiper) return;

      const paginationEl = container?.querySelector(
        '.js-people-slider-pagination',
      );
      if (!paginationEl) return;

      paginationEl.innerHTML = '';

      for (let i = 0; i < sliderInstance.swiper.slides.length; i++) {
        const bullet = document.createElement('span');
        bullet.classList.add('swiper-pagination-bullet');
        if (i === 0) bullet.classList.add('swiper-pagination-bullet-active');

        bullet.addEventListener('click', () =>
          sliderInstance.swiper?.slideTo(i),
        );
        paginationEl.appendChild(bullet);
      }
    };

    // Update active pagination bullet
    const syncPagination = () => {
      if (!sliderInstance.swiper) return;

      const paginationEl = container?.querySelector(
        '.js-people-slider-pagination',
      );
      if (!paginationEl) return;

      const bullets = paginationEl.querySelectorAll(
        '.swiper-pagination-bullet',
      );

      paginationEl
        .querySelector('.swiper-pagination-bullet-active')
        ?.classList.remove('swiper-pagination-bullet-active');
      bullets[sliderInstance.swiper.realIndex]?.classList.add(
        'swiper-pagination-bullet-active',
      );
    };

    // Initialize everything
    const init = () => {
      updateSlides(sliderInstance.swiper);
      applyTransforms();
      calculateContainerDimensions();
      createPagination();
      syncPagination();
    };

    // Setup event handlers
    if (sliderInstance.swiper) {
      sliderInstance.swiper.on('init', init);
      sliderInstance.swiper.on('slideChange', () => {
        updateSlides(sliderInstance.swiper);
        applyTransforms();
        syncPagination();
      });
      sliderInstance.swiper.on('slideChangeTransitionEnd', syncPagination);

      init();
      setupNavigation();
      window.addEventListener('resize', calculateContainerDimensions);
    }
  });
});
